import React, { useState } from 'react';
import { ZoomInIcon, ZoomOutIcon, LayersIcon } from 'lucide-react';
interface MapControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  mapMode: string;
  onMapModeChange: (mode: string) => void;
}
export const MapControls = ({
  onZoomIn,
  onZoomOut,
  mapMode,
  onMapModeChange
}: MapControlsProps) => {
  const [showLayerOptions, setShowLayerOptions] = useState(false);
  const toggleLayerOptions = () => {
    setShowLayerOptions(!showLayerOptions);
  };
  return <div className="absolute top-4 right-4 z-[500]" data-id="element-200">
      <div className="bg-white rounded-md shadow-md" data-id="element-201">
        {/* Zoom Controls */}
        <button className="p-2 hover:bg-gray-100 rounded-t-md w-10 h-10 flex items-center justify-center border-b" onClick={onZoomIn} title="জুম ইন (Zoom In)" data-id="element-202">
          <ZoomInIcon className="h-5 w-5" data-id="element-203" />
        </button>
        <button className="p-2 hover:bg-gray-100 w-10 h-10 flex items-center justify-center border-b" onClick={onZoomOut} title="জুম আউট (Zoom Out)" data-id="element-204">
          <ZoomOutIcon className="h-5 w-5" data-id="element-205" />
        </button>
        {/* Layer Control */}
        <div className="relative" data-id="element-206">
          <button className={`p-2 hover:bg-gray-100 rounded-b-md w-10 h-10 flex items-center justify-center ${showLayerOptions ? 'bg-gray-100' : ''}`} onClick={toggleLayerOptions} title="লেয়ার (Map Layers)" data-id="element-207">
            <LayersIcon className="h-5 w-5" data-id="element-208" />
          </button>
          {showLayerOptions && <div className="absolute right-0 top-full mt-1 bg-white rounded-md shadow-md w-40 overflow-hidden" data-id="element-209">
              <button className={`w-full text-left px-3 py-2 text-sm ${mapMode === 'default' ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-100'}`} onClick={() => {
            onMapModeChange('default');
            setShowLayerOptions(false);
          }} data-id="element-210">
                স্ট্রীট (Street)
              </button>
              <button className={`w-full text-left px-3 py-2 text-sm ${mapMode === 'satellite' ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-100'}`} onClick={() => {
            onMapModeChange('satellite');
            setShowLayerOptions(false);
          }} data-id="element-211">
                স্যাটেলাইট (Satellite)
              </button>
              <button className={`w-full text-left px-3 py-2 text-sm ${mapMode === 'terrain' ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-100'}`} onClick={() => {
            onMapModeChange('terrain');
            setShowLayerOptions(false);
          }} data-id="element-212">
                টেরেইন (Terrain)
              </button>
            </div>}
        </div>
      </div>
    </div>;
};